/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClaimAttachmentsPageComponent} from './claim-attachments-page.component';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {AttachmentsListDisplayModule} from '../shared/attachments-list-display/attachments-list-display.module';
import {AttachmentsListDisplayErrorModule} from '../shared/attachments-list-display-error/attachments-list-display-error.module';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule,
        AttachmentsListDisplayModule,
        AttachmentsListDisplayErrorModule
    ],
    declarations: [ClaimAttachmentsPageComponent]
})
export class ClaimAttachmentsPageModule {
}
